import React, { useState, useEffect } from "react";
import api from "../services/api";
const statusColors = { pending: "#E65100", review: "#1565C0", approved: "#1A5C2A", rejected: "#D32F2F" };
const statusLabels = { pending: "En attente", review: "En examen", approved: "Approuve", rejected: "Rejete" };
export default function UrbanPage() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [notes, setNotes] = useState("");
  useEffect(() => { loadRequests(); }, []);
  const loadRequests = () => {
    setLoading(true);
    api.get("/urban-planning/requests/").then(r => { setRequests(r.data); setLoading(false); }).catch(() => setLoading(false));
  };
  const handleUpdate = async () => {
    try {
      await api.patch(`/urban-planning/requests/${selected.id}/`, { status: newStatus, admin_notes: notes });
      setSelected(null);
      loadRequests();
    } catch { alert("Erreur"); }
  };
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: "#1A1A2E", fontSize: 24, fontWeight: 800, margin: 0 }}>Urbanisme</h1>
        <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>{requests.length} demande(s) de permis</p>
      </div>
      {selected && (
        <div style={{ background: "white", borderRadius: 20, padding: 28, marginBottom: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", border: "2px solid #37474F" }}>
          <h3 style={{ margin: "0 0 16px" }}>Traiter: {selected.permit_type_display}</h3>
          <p style={{ color: "#8A8A9A", fontSize: 13 }}>Demandeur: {selected.full_name} • Ref: {selected.reference}</p>
          <p style={{ color: "#8A8A9A", fontSize: 13 }}>Localisation: {selected.location}</p>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Nouveau statut</label>
            <select value={newStatus || selected.status} onChange={e => setNewStatus(e.target.value)}
              style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none" }}>
              {Object.entries(statusLabels).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Notes administratives</label>
            <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={3} placeholder="Notes pour le citoyen..."
              style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" }} />
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <button onClick={handleUpdate} style={{ background: "#37474F", color: "white", border: "none", padding: "10px 24px", borderRadius: 10, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "Poppins" }}>Mettre a jour</button>
            <button onClick={() => setSelected(null)} style={{ background: "#F5F6FA", color: "#8A8A9A", border: "none", padding: "10px 24px", borderRadius: 10, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "Poppins" }}>Annuler</button>
          </div>
        </div>
      )}
      {loading ? <p style={{ textAlign: "center", color: "#8A8A9A" }}>Chargement...</p> : (
        <div style={{ display: "grid", gap: 12 }}>
          {requests.map(r => (
            <div key={r.id} style={{ background: "white", borderRadius: 16, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", display: "flex", justifyContent: "space-between", alignItems: "center", borderLeft: `4px solid ${statusColors[r.status] || "#8A8A9A"}` }}>
              <div>
                <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
                  <span style={{ background: (statusColors[r.status] || "#8A8A9A") + "20", color: statusColors[r.status] || "#8A8A9A", padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700 }}>{statusLabels[r.status] || r.status}</span>
                  <span style={{ background: "#F5F6FA", color: "#8A8A9A", padding: "3px 10px", borderRadius: 6, fontSize: 11 }}>{r.reference}</span>
                </div>
                <h3 style={{ margin: "0 0 4px", fontSize: 15, fontWeight: 700, color: "#1A1A2E" }}>{r.permit_type_display}</h3>
                <p style={{ margin: 0, fontSize: 13, color: "#8A8A9A" }}>👤 {r.full_name} • 📍 {r.location} • {r.created_at?.substring(0, 10)}</p>
              </div>
              <button onClick={() => { setSelected(r); setNewStatus(r.status); setNotes(r.admin_notes || ""); }}
                style={{ background: "#37474F20", color: "#37474F", border: "none", padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "Poppins" }}>
                Traiter
              </button>
            </div>
          ))}
          {requests.length === 0 && <div style={{ textAlign: "center", padding: 60, color: "#8A8A9A" }}>Aucune demande de permis</div>}
        </div>
      )}
    </div>
  );
}